export const ProspectType = {
  SHIPPER: 'SHIPPER',
  CARRIER: 'CARRIER',
  FORWARDER: 'FORWARDER',
};
